import { useState } from 'react';
import { TableInput } from '../../../../../../components/common';
import { createConstant } from '../../constant';
import TBodyRight from './TBodyRight';
import formatDate from '../../../../../../components/common/formatDate';
import InputMuiCustom from '../../../../../../components/common/inputs/InputMuiCustom';
import { SelectChangeEvent } from '@mui/material';
import DatePickerMui from '../../../../../../components/common/DatePickerMui';
// import dayjs, { Dayjs } from 'dayjs';
import moment from 'moment';
interface IProps {
  moduleData: any;
  allmonth: any;
  isView: boolean;
  handleDoubleClick: any;
}

const allmonth = [
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
  'january',
  'february',
  'march',
];

const TBody = ({ moduleData, isView, allmonth, handleDoubleClick }: IProps) => {
  const [render, setRender] = useState(false);
  const [data, setData] = useState<any>({});

  console.log('gggggggggggggggggggggggggg');
  return (
    <tbody>
      {moduleData?.maintenance_list?.map((item: any, prvIndex: any) => (
        <>
          <tr className="listDataCenter">
            <td rowSpan={2}>{prvIndex + 1}</td>
            <td rowSpan={2}>
              {item.machine_no ? item.machine_no : item.machine_id.machine_no}
            </td>
            <td rowSpan={2}>
              {item.machine_name
                ? item.machine_name
                : item.machine_id.machine_name}
            </td>
            <td rowSpan={2}>{item.area ? item.area : item.machine_id.area}</td>
            <td>P</td>
            {[
              ['april', 4, new Date(moduleData.date_range).getFullYear()],
              ['may', 5, new Date(moduleData.date_range).getFullYear()],
              ['june', 6, new Date(moduleData.date_range).getFullYear()],
              ['july', 7, new Date(moduleData.date_range).getFullYear()],
              ['august', 8, new Date(moduleData.date_range).getFullYear()],
              ['september', 9, new Date(moduleData.date_range).getFullYear()],
              ['october', 10, new Date(moduleData.date_range).getFullYear()],
              ['november', 11, new Date(moduleData.date_range).getFullYear()],
              ['december', 12, new Date(moduleData.date_range).getFullYear()],
              ['january', 1, new Date(moduleData.date_range).getFullYear() + 1],
              [
                'february',
                2,
                new Date(moduleData.date_range).getFullYear() + 1,
              ],
              ['march', 3, new Date(moduleData.date_range).getFullYear() + 1],
            ].map((month) => (
              <td
                style={{
                  padding: '0px',
                  margin: '0px',
                }}
              >
                <DatePickerMui
                  label=""
                  // name="date_performance"
                  // className="date-field"
                  // inputVariant="filled"
                  // style={{ width: '120px' }}
                  // clearable
                  // format="dd/MM/yyyy"
                  minDate={moment(new Date(`${month[1]}/01/${month[2]}`))}
                  maxDate={moment(
                    new Date(
                      `${month[1]}/${new Date(
                        +month[2],
                        +month[1],
                        0
                      ).getDate()}/${month[2]}`
                    )
                  )}
                  value={moment(item[month[0]]?.created_date || null)}
                  onChange={(date: any) => {
                    console.log('ggggggggggggggg', date, month[0], prvIndex);
                    handleDoubleClick(date, month[0], prvIndex);
                  }}
                  // InputProps={{
                  //   disableUnderline: true,
                  // }}
                  // clearable
                  // clear
                />
              </td>
            ))}
            <td
              contentEditable={true}
              data-name="remarks"
              onKeyUp={(e: any) => {
                item[e.target.dataset.name] = e.target.innerText;
              }}
              style={{
                border: '1px solid black',
                backgroundColor: '#f9e0e0',
              }}
            >
              <span>{item.remarks}</span>
            </td>
          </tr>
          <tr className="listDataCenter">
            <td>A</td>
            {[
              'april',
              'may',
              'june',
              'july',
              'august',
              'september',
              'october',
              'november',
              'december',
              'january',
              'february',
              'march',
            ].map((month) => (
              <td
                height="75px"
                width="75px"
                style={{
                  backgroundColor: item[month].doneDate && '#37b24d',
                  color: 'white',
                  textTransform: 'capitalize',
                }}
              >
                {item[month].doneDate}
              </td>
            ))}
            <td
              contentEditable={true}
              data-name="remarks"
              onKeyUp={(e: any) => {
                item[e.target.dataset.name] = e.target.innerText;
              }}
              style={{
                border: '1px solid black',
                backgroundColor: '#f9e0e0',
              }}
            >
              <span>{item.remarks}</span>
            </td>
          </tr>
        </>
      ))}
      {/* {moduleData?.list?.map((item: any, index: number) => (
        <>
          <tr key={`${index}_table_row`}>
            <td>{index + 1}</td>
            <td>{item?.item}</td>
            {allmonth.map((monthName: string) => {
              return (
                <td>
                  <TableInput
                    isView={
                      index === 1 ||
                      index === 3 ||
                      index === 5 ||
                      index === 7 ||
                      index === 9
                        ? true
                        : false
                    }
                    style={{
                      height: '80px',
                      textAlign: 'center',
                      paddingLeft: '10px',
                    }}
                    name=""
                    type="number"
                    value={
                      (index === 3 &&
                        getPlanedProuctionTimePerMachine(monthName)) ||
                      (index === 5 && runTime(monthName)) ||
                      (index === 7 && operationTime(monthName)) ||
                      (index === 9 && mtbf(monthName)) ||
                      item[monthName]
                    }
                    onChange={(e) => {
                      item[monthName] = e.target.value;
                      setRender((prev) => !prev);
                    }}
                  />
                </td>
              );
            })}
            <td>{getAverage(index)}</td>
            <td>
              <InputMuiCustom
                placeholder={''}
                name=""
                type="text"
                value={item?.remarks}
                onChange={(e) => {
                  item.remarks = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
          </tr>
        </>
      ))}
      <tr>
        <td></td>
        <td>Target</td>
        {allmonth.map((montName: string) => {
          return (
            <td>
              <TableInput
                isView={isView}
                style={{
                  height: '80px',
                  textAlign: 'center',
                  paddingLeft: '10px',
                }}
                name=""
                type="number"
                value={moduleData?.[`target_${montName}`]}
                onChange={(e) => {
                  moduleData[`target_${montName}`] = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
          );
        })}
        <td>{getTargetAverage()}</td>
        <td></td>
      </tr> */}
    </tbody>
  );
};

export default TBody;
